module.exports = __webpack_public_path__ + "static/media/professional.cdcfc92f.svg";